export const strength = require('./strength.png');
export const speed = require('./speedometer.png');
export const combat = require('./knife.png');
export const intelligence = require('./thinking.png');
export const durability = require('./shield.png');
export const power = require('./power.png');